import { Box, Typography } from '@mui/material';
import React from 'react';

import FirstColumnContainer from './FirstColumnContainer';
import { ExtendedTranslatedNameType } from '../../../redux/types';

type RowContainerProps = {
  option: ExtendedTranslatedNameType;
  startCase: number;
  index: number;
  children: React.ReactNode;
};

const RowContainerList: React.FC<RowContainerProps> = ({
  option, startCase, index, children,
}: RowContainerProps) => {
  const bacgkroundColor = ['rgb(117, 195, 240, 0.2)', 'rgb(117, 195, 240, 0.5)', 'rgb(117, 195, 240, 0.7)'];
  return (
    <Box key={`option-container-${option.uuid}-${startCase}`}>
      <div className="flex nowrap">
        <div id={option.highlight ? `highlight-${option.uuid}` : undefined} className="pb1 pt1 pl1" style={{ minWidth: 400, whiteSpace: 'pre-wrap', background: bacgkroundColor[index % 3] }}>
          <FirstColumnContainer>
            <Typography variant="body1">{option.text}</Typography>
          </FirstColumnContainer>
        </div>
        <ul className="flex ma0 list nowrap pl0 basis-100" style={{ background: bacgkroundColor[index % 3] }}>
          {children}
        </ul>
      </div>
    </Box>
  );
};

export default RowContainerList;
